// extracted by mini-css-extract-plugin
module.exports = {"error":"MenuPage-error__error___MCAR1","modal":"MenuPage-error__modal___3FpP6","text":"MenuPage-error__text___3qFH7","header":"MenuPage-error__header___2lJLE"};